<template>
  <div>
    <form class="clearfix" @submit.prevent="getMessages(1)">
      <ul class="filter_form clearfix">
        <li class="filter_form__items">
          <label class="filter_form__label" for="type-filter">{{
            $t('pages.sentMessages.messageFilters.type')
          }}</label>
          <BaseSelect
            v-model="messageParams.type"
            :options="messageTypes"
            :reduce="(option) => option.code"
            id="type-filter"
            clearable
          />
        </li>

        <li class="filter_form__items">
          <label class="filter_form__label" for="subject-filter">{{
            $t('pages.sentMessages.messageFilters.subject')
          }}</label>
          <input
            v-model="messageParams.subject"
            id="subject-filter"
            type="text"
            class="form-control"
          />
        </li>

        <li class="filter_form__items">
          <label class="filter_form__label" for="sender-filter">{{
            $t('pages.messages.messageFilters.sender')
          }}</label>
          <input
            v-model="messageParams.sender"
            id="sender-filter"
            type="text"
            class="form-control"
          />
        </li>

        <li class="filter_form__items">
          <label class="filter_form__label" for="recipient-filter">{{
            $t('pages.sentMessages.messageFilters.recipient')
          }}</label>
          <input
            v-model="messageParams.recipient"
            id="recipient-filter"
            type="text"
            class="form-control"
          />
        </li>

        <li class="filter_form__items filter_form__items--full">
          <button
            :disabled="loadingMessages"
            type="submit"
            class="btn btn-feat btn-mobile-full pull-right"
          >
            {{ $t('actions.updateResults') }}
          </button>
        </li>
      </ul>
    </form>

    <BaseTable
      :headers="messageTableHeaders"
      :items="messages"
      :pagination="messagePagination"
      :loading="loadingMessages"
      :on-row-click="viewMessage"
      enable-sorting
      @update:sorting="setOrderBy"
      @update:page="getMessages"
    >
      <template #item.recipient="{ item }">
        <MessageRecipients :recipients="item.recipient" />
      </template>
      <template #item.body="{ item }">
        <BaseTruncatedField v-if="item.body" :value="item.body" display-html />
      </template>
      <template #item.sentDate="{ item }">
        <div class="text-nowrap">
          {{ $formatDate(item.sentDate, 'yyyy-MM-dd HH:mm') }}
        </div>
      </template>
    </BaseTable>
  </div>
</template>

<script>
import BaseSelect from './base/BaseSelect';
import messageService from '../services/message.service';
import BaseTruncatedField from './base/BaseTruncatedField';
import MessageRecipients from './MessageRecipients';
import BaseTable from './base/BaseTable';

export default {
  name: 'MessagesSent',

  components: { BaseTable, MessageRecipients, BaseTruncatedField, BaseSelect },

  props: {
    messageTypes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      loadingMessages: false,
      messages: [],
      messagePagination: {},
      messageParams: {},
    };
  },

  computed: {
    messageTableHeaders() {
      const translationKey = 'pages.sentMessages.messageTable.headers';
      return [
        { text: this.$t(`${translationKey}.type`), value: 'type.name' },
        { text: this.$t(`${translationKey}.sender`), value: 'sender' },
        { text: this.$t(`${translationKey}.recipient`), value: 'recipient' },
        { text: this.$t(`${translationKey}.subject`), value: 'subject' },
        { text: this.$t(`${translationKey}.body`), value: 'body' },
        { text: this.$t(`${translationKey}.sentDate`), value: 'sentDate' },
      ];
    },
  },

  created() {
    this.getMessages();
  },

  methods: {
    getMessages(page = 1) {
      this.loadingMessages = true;
      const params = { ...this.messageParams, page };
      messageService
        .getOutboxList(params)
        .then((res) => {
          this.messages = res.data.outboxMessage;
          this.messagePagination = {
            page: res.data.page,
            total: res.data.total,
            pageSize: res.data.pageSize,
          };
        })
        .catch(() => {
          this.messages = [];
          this.messagePagination = {};
        })
        .finally(() => {
          this.loadingMessages = false;
        });
    },

    setOrderBy(string) {
      this.$set(this.messageParams, 'orderBy', string);
      this.getMessages();
    },

    viewMessage(message) {
      window.location.href = this.$url(
        `${this.$t('pages.message.url')}?id=${message.messageId}&outbox=1`
      );
    },
  },
};
</script>
